/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var InfoCircleIcon32Regular = forwardRef('InfoCircleIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M17.014 10.763a1.376 1.376 0 1 1-2.752 0 1.376 1.376 0 0 1 2.752 0Z" }),
        React.createElement("path", { d: "M14.5 14.125a.875.875 0 1 0 0 1.75h.71v5.25h-1.462a.875.875 0 1 0 0 1.75h4.504a.875.875 0 0 0 0-1.75h-1.293V15.5c0-.76-.615-1.375-1.374-1.375H14.5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 16C3 8.82 8.82 3 16 3s13 5.82 13 13-5.82 13-13 13S3 23.18 3 16ZM16 5C9.925 5 5 9.925 5 16s4.925 11 11 11 11-4.925 11-11S22.075 5 16 5Z" })));
});
